import { AfterViewInit, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { differenceInDays, startOfDay } from 'date-fns';
import { DateUtilService } from 'gung-common';
import { ListItemRendererComponent } from 'gung-list';
import { Subject } from 'rxjs';
import { Order } from '../../../../models/order';
import { GungCurrencyPipe } from '../../../../pipes/gung-currency.pipe';
import { LocationConfigService } from '../../../../services/location-config/location-config.service';

@Component({
  selector: 'lib-production-management-orders-to-pick-table',
  templateUrl: './production-management-orders-to-pick-table.component.html',
  styleUrls: ['./production-management-orders-to-pick-table.component.css'],
  standalone: false
})
export class ProductionManagementOrdersToPickTableComponent extends ListItemRendererComponent<Order[]> implements AfterViewInit {
  protected locationConfigService = inject(LocationConfigService);
  protected router = inject(Router);
  public dateUtilService = inject(DateUtilService);
  public gungCurrencyPipe = inject(GungCurrencyPipe);
  
  adjustedScroll = false;
  protected unsubscribe: Subject<void> = new Subject();
  activeRemarkId: string | null = null;

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  classSelector(key: number) {
    if (key === 13) {
      return {
        registered: true
      };
    }
    if (key === 11) {
      return {
        quote: true
      };
    }
    if (key === 10) {
      return {
        registrationInProgress: true
      };
    }
    if (key === 12) {
      return {
        blocked: true
      };
    }
    if (key === 5) {
      return {
        webRegistrationInProgress: true
      };
    }

    return {};
  }
  
  getCssClass(order) {
    if (order.extra.Order.InvoiceReference !== '0') {
      // already invoiced
      return '';
    }

    const date = order.extra.Order.OrderDate;
    const now = startOfDay(new Date());
    const oldDate = startOfDay(new Date(date));
    const days = differenceInDays(now, oldDate);

    if (days > 30) {
      return 'badge badge-pill badge-danger';
    } else if (days > 15) {
      return 'badge badge-pill badge-warning';
    } else {
      return '';
    }
  }

  toggleRemark(event: Event, orderId: string): void {
    event.stopPropagation();
    this.activeRemarkId = this.activeRemarkId === orderId ? null : orderId;
  }
}
